import * as Business            from '../business';
import * as User                from '../user';
import { compose }              from 'redux';
import { connect }              from 'react-redux';
import asFullScreen             from '../components/as_full_screen';
import Navbar                   from '../components/navbar';
import PrimaryButton            from '../components/primary_button';
import React                    from 'react';
import ResourceUnavailableImage from '../assets/images/resource-unavailable.svg';
import rollbar                  from '../rollbar';


const queryStringParamsRequired = [ 'requestID', 'companyKey', 'companyName'  ];

class ServiceMonsterPage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state        = {
      params:     {},
      businessID: null
    };
    this.handleClick  = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClick(businessID) {
    return async event => {
      event.preventDefault();
      this.setState({ businessID });
    };
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { businessID } = this.state;
    await this.update(businessID);
  }

  static getDerivedStateFromProps({ query }) {
    const params = getValidParams(query);

    return {
      params
    };
  }

  async update(businessID) {
    const { updateDataSource } = this.props;
    const { navigateTo }       = this.props;
    const { params }           = this.state;

    await updateDataSource({ businessID, ...params });
    navigateTo(`/${businessID}/settings/data_sources`, { clearPreviousHistory: true });
  }

  async componentDidMount() {
    const { params } = this.state;

    const hasValidParams = Object.keys(params).length === queryStringParamsRequired.length;
    if (hasValidParams) {
      const { locations } = this.props;
      if (locations.length === 1)
        await this.update(locations[0].id);
    } else {
      const error  = new Error('Missing required params for integration service monster');
      error.params = params;
      rollbar.error(error);
    }
  }

  render() {
    const { params }         = this.state;
    const { locations }      = this.props;
    const hasValidParams     = Object.keys(params).length === queryStringParamsRequired.length;
    const isMultipleLocation = locations?.length > 0;
    const { companyName }    = params;
    const { businessID }     = this.state;
    const canSubmit          = !!businessID;

    if (hasValidParams) {
      return (
        <React.Fragment>
          <Navbar title="Service Monster"/>
          <div className="page-content">
            {isMultipleLocation && (
              <React.Fragment>
                <ConnectCompany name={companyName}/>
                <Locations selectedID={businessID} locations={locations} onClick={this.handleClick}/>
                <div className="row buttons-row justify-content-center">
                  <button className="button button-fill col-33" onClick={this.handleSubmit} disabled={!canSubmit}>Connect</button>
                </div>
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      );
    } else
      return <MissingInformation/>;
  }
}


function ConnectCompany({ name }) {
  return (
    <div className="list media-list inset">
      <ul>
        <li className="list-group-title">Connect this service monster account</li>
        <li>
          <div className="item-content item-inner">
            <div className="item-title-row">
              <div className="item-title">{name}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}


function Locations({ locations, selectedID, onClick }) {
  return (
    <div className="list media-list inset">
      <ul>
        <li className="list-group-title">To this Broadly location</li>
        {locations.map(location => (
          <Location
            key={location.id}
            name={location.name}
            address={location.address}
            isSelected={location.id === selectedID}
            onClick={onClick(location.id)}
          />
        ))}
      </ul>
    </div>
  );
}


function Location({ name, address, isSelected, onClick }) {
  return (
    <li>
      <a onClick={onClick}>
        <div className="item-content item-inner item-link no-background">
          <div className="item-title-row">
            <div className="item-title">{name}</div>
            <div className="item-after">
              {isSelected && <i className="icon f7-icons">check</i>}
            </div>
          </div>
          <div className="item-text">{address}</div>
        </div>
      </a>
    </li>
  );
}


function MissingInformation() {
  return (
    <div className="page-content">
      <div className="startup-error">
        <div className="startup-error__logo"/>
        <ResourceUnavailableImage className="startup-error__image"/>
        <h1>We have an error</h1>
        <div className="startup-error__cta">
          <p>We had an error while trying to connect your ServiceMonster account.</p>
          <PrimaryButton label="Try again" href="https://six.servicemonster.net/desktop#marketplace/item/f7be6af9-3441-11e8-8c1a-fec578518208" external/>
        </div>
      </div>
    </div>
  );
}


function getValidParams(query = {}) {
  return Object.entries(query)
    .filter(([ key ]) => queryStringParamsRequired.includes(key))
    .reduce((acc, entry) => {
      acc[entry[0]] = entry[1]; // eslint-disable-line
      return acc;
    }, {});
}


export default connect(
  state => ({
    locations: User.getLocations(state)
  }),
  (dispatch, { navigateTo }) => ({
    updateDataSource: ({ businessID, ...body }) => {
      const name = 'servicemonster';
      return compose(dispatch, Business.replaceDataSource)({ businessID, name, ...body });
    },
    navigateTo
  })
)(asFullScreen(ServiceMonsterPage));
